/**
 * Fill product-card Stamped badges, including cards added after filters or infinite scroll.
 * Product pages already render the Stamped app block; cards use the same product id and SKU.
 */
(function () {
  var refreshing = false;

  function hasStamped() {
    return window.StampedFn && typeof window.StampedFn.loadBadges === 'function';
  }

  function refreshStampedCardBadges() {
    if (!hasStamped()) return false;
    if (!document.querySelector('.card__stamped-rating:not(:has(.stamped-badge))')) return true;
    if (refreshing) return true;
    refreshing = true;
    try {
      window.StampedFn.loadBadges();
    } catch (error) {
      refreshing = false;
      return false;
    }
    window.setTimeout(function () {
      refreshing = false;
    }, 400);
    return true;
  }

  function addedCardBadge(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('.card__stamped-rating, product-card, .js-pagination-result')) return true;
    return !!(node.querySelector && node.querySelector('.card__stamped-rating'));
  }

  function boot() {
    refreshStampedCardBadges();

    if (!document.body || document.body.dataset.stampedCardWatch === 'true') return;
    document.body.dataset.stampedCardWatch = 'true';

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          if (addedCardBadge(nodes[j])) {
            refreshStampedCardBadges();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('on:facet-filters:updated', refreshStampedCardBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var tries = 0;
  var poll = window.setInterval(function () {
    tries += 1;
    if (refreshStampedCardBadges() || tries > 25) window.clearInterval(poll);
  }, 300);
})();
